<div class="row">
  <div class="column">
    <app-rental-property-info [property]="property"></app-rental-property-info>
    <form [formGroup]="propertyForm">
      <div class="row">
        <mat-checkbox formControlName="usePlatformForRent" class="column">
          I don’t use any platform to rent out my property <mat-icon svgIcon="exclamation-icon"
            matTooltip="In an effort to ensure compliance of all short term/vacation rentals we ask that you provide the rental advertisements and websites that you utilize. Example: airbnb.com/rooms/12345678"
            matTooltipPosition="above" /></mat-checkbox>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Digital platforms (one per line)</mat-label>
          <textarea formControlName="digitalPlatform" matInput rows="3" placeholder="Airbnb: airbnb.com/rooms/123 (one platform per line)"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="column">
    <app-property-additional-owner [owners]="owners"></app-property-additional-owner>
  </div>
</div>
